import React from "react";
import { X } from "lucide-react";
import ReactModal from "react-modal";
import { Box, Button } from "theme-ui";
import { colors } from "../../styles/theme";

const VideoPopup = ({ isModalOpen, setIsModalOpen, videoUrl }) => {
  const closeModal = (event) => {
    event.preventDefault();
    setIsModalOpen(false);
  };

  return (
    <ReactModal
      isOpen={isModalOpen}
      closeTimeoutMS={150}
      contentLabel=""
      shouldCloseOnOverlayClick={true}
      onRequestClose={closeModal}
      ariaHideApp={false}
      style={styles.modal}
    >
      <Box sx={styles.video}>
        <video controls autoPlay playsInline preload="auto">
          <source src={videoUrl} type="video/mp4" />
        </video>
      </Box>
      <Button onClick={closeModal} sx={styles.closeBtn}>
        <X color={colors.primaryMain} strokeWidth={4} size={24} />
      </Button>
    </ReactModal>
  );
};

const styles = {
  modal: {
    content: {
      position: "absolute",
      top: "3rem",
      width: "fit-content",
      height: "fit-content",
      padding: 0,
      margin: "auto",
      backgroundColor: "transparent",
      border: "none",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    overlay: {
      zIndex: 1040,
      overflowY: "scroll",
      display: "flex",
      justifyContent: "center",
      backgroundColor: "rgba(0, 0, 0, 0.75)",
    },
  },
  closeBtn: {
    backgroundColor: "transparent",
    width: "max-content",
    alignSelf: "flex-start",
    "@media(max-width: 899px)": {
      display: "none",
    },
  },
  video: {
    width: ["300px", "300px", "400px", "777.5px"],
    height: ["auto", "auto", "auto", "493.94px"],
    borderRadius: "1.5rem",
    video: { width: "100%", borderRadius: "0.75rem" },
  },
};

export default VideoPopup;
